export {
  AUTH_ENDPOINTS,
  COMPANY_ENDPOINTS,
  COMPANIES_ENDPOINTS,
  CREATION_REQUEST_ENDPOINTS,
  STORAGE_KEYS,
  API_ERRORS,
  NOTIFICATION_TOPICS,
  NOTIFICATION_TYPES,
  FCM_ENDPOINTS,
  FCM_MESSAGE_TYPES,
  FCM_UPDATE_TYPES,
  SUBTRACE_ENDPOINTS,
}

const AUTH_BASE_URL = '/auth'
const PRODUCT_BASE_URL = '/product'
const COMPANY_BASE_URL = '/company'
const COMPANIES_BASE_URL = `/companies`
const FCM_BASE_URL = '/fcm'
const SUBTRACE_BASE_URL = '/subtrace'

const AUTH_ENDPOINTS = {
  LOGIN: `${AUTH_BASE_URL}/web-login`,
  GOOGLE_LOGIN: `${AUTH_BASE_URL}/sign-in-with-google`,
}

const COMPANIES_ENDPOINTS = {
  GET: `${COMPANIES_BASE_URL}/get-all`,
}

const CREATION_REQUEST_ENDPOINTS = {
  GET: `${COMPANIES_BASE_URL}/creation-requests-get`,
  EDIT: `${COMPANIES_BASE_URL}/creation-requests-edit`,
}
// /fcm/topic/subscribe
// /fcm/topic/unsubscribe
// /fcm/topic/unsubscribe-all
const COMPANY_ENDPOINTS = {
  GET: `${COMPANY_BASE_URL}/get-info`,
  CREATE: `${COMPANY_BASE_URL}/new`,
  UPDATE: `${COMPANY_BASE_URL}/edit`,
  DELETE: `${COMPANY_BASE_URL}/delete`,
  CREATE_AI_ASSESSMENT: `${COMPANY_BASE_URL}/create-ai-assessment`,
  CREATE_PRODUCT: `${PRODUCT_BASE_URL}/new`,
  DELETE_PRODUCT: `${PRODUCT_BASE_URL}/delete`,
  GET_SUGGESTIONS: `${COMPANY_BASE_URL}/get-new-suggestions`,
  GENERATE_ASSESSMENT_DOC: `${COMPANY_BASE_URL}/assessment-to-google-drive`,
  GET_SUBPROCESSOR_LIST: `${COMPANY_BASE_URL}/subprocessor-list`,
  TRIGGER_SUBPROCESSOR_LIST: `${COMPANY_BASE_URL}/trigger-subprocessor-list`,
  UPLOAD_SUBPROCESSOR_LIST_FILE: `${COMPANY_BASE_URL}/upload-subprocessor-list-file`,
  EDIT_SUBPROCESSOR_LIST: `${COMPANY_BASE_URL}/edit-subprocessor-list`,
  SUBPROCESSOR_LIST_NOTES: `${COMPANY_BASE_URL}/subprocessor-list-notes`,
  GET_RAW_SUBPROCESSORS: `${COMPANY_BASE_URL}/get-raw-subprocessors`,
  SUBPROCESSOR_REVERSE: `${COMPANY_BASE_URL}/subprocessor-reverse`,
  NOTES_GET: `${COMPANY_BASE_URL}/notes-get`,
  NOTES_EDIT: `${COMPANY_BASE_URL}/notes-edit`,
  FILE_LINK_GET: `${COMPANY_BASE_URL}/file-link-get`,
  FILE_DELETE: `${COMPANY_BASE_URL}/file-delete`,
  FETCH_ATTACHMENTS: `${COMPANY_BASE_URL}/attachments-fetch`,
}

const FCM_ENDPOINTS = {
  SUBSCRIBE_TO_TOPIC: `${FCM_BASE_URL}/subscribe`,
  UNSUBSCRIBE_FROM_TOPIC: `${FCM_BASE_URL}/unsubscribe`,
  UNSUBSCRIBE_FROM_ALL_TOPICS: `${FCM_BASE_URL}/unsubscribe-all`,
  UPDATE_TOKEN: `${FCM_BASE_URL}/update-token`,
}

const FCM_MESSAGE_TYPES = {
  BACKGROUND: 'FCM_BACKGROUND_MESSAGE',
}

/** New FCM payload types — handled by useFcmUpdates only. Add entries as backend ships events. */
const FCM_UPDATE_TYPES = {}

const SUBTRACE_ENDPOINTS = {
  CREATE_GRANT: `${SUBTRACE_BASE_URL}/new`,
}

const STORAGE_KEYS = {
  LOGGED_IN_USER: 'LOGGED_IN_USER',
  COMPANIES: 'COMPANIES_CACHE',
  COMPANY: 'COMPANY_CACHE',
  LAST_FILTER_KEY: 'COMPANIES_FILTER',
  LAST_TABLE_STATE_KEY: 'COMPANIES_TABLE_STATE',
  PRODUCT: 'PRODUCT_CACHE',
  COMPANY_SUBPROCESSORS: 'COMPANY_SUBPROCESSORS_CACHE',
  COMPANY_SUBPROCESSOR_REVERSE: 'COMPANY_SUBPROCESSOR_REVERSE_CACHE',
  SUBPROCESSOR_LIST: 'SUBPROCESSOR_LIST_CACHE',
  CREATION_REQUESTS: 'CREATION_REQUESTS_CACHE',
  CREATION_REQUESTS_LAST_FILTER_KEY: 'CREATION_REQUESTS_FILTER',
  CREATION_REQUESTS_LAST_TABLE_STATE_KEY: 'CREATION_REQUESTS_TABLE_STATE',
  NOTIFICATIONS: 'NOTIFICATIONS',
  FCM_TOKEN_CACHE: 'FCM_TOKEN_CACHE',
  COMPANY_NOTES: 'COMPANY_NOTES_CACHE',
}

const API_ERRORS = {
  AUTH_ERROR: 'Authentication failed',
  UNAUTHORIZED: 'Unauthorized',
}

// Firebase Cloud Messaging Topics
const NOTIFICATION_TOPICS = {
  AI_ASSESSMENT: (companyId, productId) => {
    let topic = `ai-assessment-${companyId}`
    if (productId) topic += `-product-${productId}`
    return topic
  },
  USER_NOTIFICATION: (userId) => `user-notification-${userId}`,
  COMPANY_EDIT: (companyId) => `edit-company-${companyId}`,
  PRODUCT_EDIT: (companyId, productId) => `edit-company-${companyId}-product-${productId}`,
  TEST: 'test-notifications',
}

const NOTIFICATION_TYPES = {
  AI_ASSESSMENT: 'ai-assessment-updates',
  COMPANY_EDIT: 'company-edit-updates',
  PRODUCT_EDIT: 'product-edit-updates',
  USER_NOTIFICATION: 'user-notification-updates',
  TEST: 'test-notifications',
}
